/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable react/prop-types */
import { ICellTextProps } from "ka-table/props";
import React from "react";
import ProfileImg from "../ui/icons/ProfileImg";
import useObjectDrawerStore from "../../store/drawer/objectDrawerStore";

const AvatarCell: React.FC<ICellTextProps> = React.memo(
  ({
    column, ...props
  }) => {
    const { openDrawer } = useObjectDrawerStore();

    const value = props.rowData[`${column.key}`];
    const displayName = value?.name || value?.externalId || "-";

    const handleAvatarClick = (event: React.MouseEvent) => {
      if (!value?.externalId) return;
      event.stopPropagation();
      const entityType = (value?.relation === "user" || column.key.includes("users")) ? "users" : "accounts";
      openDrawer({
        objectType: entityType,
        objectId: value.externalId,
      });
    };

    return (
      <button
        type="button"
        onClick={handleAvatarClick}
        className="w-full text-left"
      >
        <span className="flex items-center gap-3 max-w-full">
          <ProfileImg
            desc={value?.desc}
            img={value?.img}
            name={displayName}
            size="sm"
            width={32}
            height={32}
            rounded={false}
          />
          <span className="text-sm font-medium text-gray-900 truncate">{displayName}</span>
        </span>
      </button>
    );
  },
);

export default AvatarCell;
